export { ResultCard } from './ResultCard';
